import React from 'react';
import FormROValue from "../../../../library/form/components/FormROValue1"
import FormLabel from "../../../../library/form/components/FormLabel"
import FormLink from "../../../../library/form/components/FormLink"
import SarasTrans from '../../../../library/notifications/SarasTrans';

const ItemForecastRow = (props) => {
    const { formObject, rowKey } = props;

    // console.log(rowKey);

    return (
        <li className="list-row uiSearchRow">
            <div>
                
                <div className="uiSpacer5">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "fcType" }} value="Action" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "fcType" }} />

                    <span className="uiLblInLine">
                        <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "fcQty" }} value="Quantity" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "fcQty" }} />

                </div>
                <div className="uiSpacer5">
                    <span className="uiLbl"><SarasTrans value = "Location"/></span>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "acLocation" }} />
                </div>
                <div className="uiSpacer5">
                    <span className="uiLbl"><SarasTrans value = "Against"/>
                    </span>
                    <span className="uiLblInLine">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "docType" }} />
                    </span>

                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "docId", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>

                    <span className="uiLblInLine">
                        <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "docDate" }} value="Date" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "docDate" }} />
                </div>
            </div>
        </li>
    )
}

export default ItemForecastRow